var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"myEchart",style:({ height: '600px', width: '100%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }